import styled from 'styled-components';
import { breakpoints } from 'assets/breakpoints';


export const BodyHeader = styled.div`
  grid-area: header;
  display: grid;
  background: black;
  height: 60px;
  align-items: center;
  justify-content: center;
  border-bottom: 1px grey solid;
  
  @media (min-width: ${breakpoints.desktop}) {
   height: 250px;                    
  }
`;

export const Logo = styled.img`
  border: 0;
  display: flex;
  height: 20px;
`;
